import * as tslib_1 from "tslib";
import { NgZone } from "@angular/core";
import { BaseComponent } from "../../../../base/base.component";
import { PRIVATE_NURSERY_DETAIL_ROUTE, PRIVATE_NURSERY_SPHERE_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { NurseryManager } from "../../../../../business/managers/nursery.manager";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { forkJoin } from "rxjs";
import { MapsAPILoader } from "@agm/core";
import { CLICK_EVENT, MAP_INITIAL_LATITUDE, MAP_INITIAL_LONGITUDE, MAP_STYLE, MOUSE_OUT_EVENT, MOUSE_OVER_EVENT, POLYGON_COMPLETE_EVENT, POLYGON_OPTIONS } from "../../../../../crossconcern/utilities/properties/map.properties";
import { finalize } from "rxjs/operators";
import { PhotosphereManager } from "../../../../../business/managers/photosphere.manager";
import { PolylineItem } from "../../../../../datastore/entities/polylineitem.model";
import { PathItem } from "../../../../../datastore/entities/pathitem.model";
import { logData } from "../../../../../crossconcern/helpers/generic/generic.helper";
import { mergeMap } from "rxjs/internal/operators";
var NurseryMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryMapComponent, _super);
    function NurseryMapComponent(appComponent, router, location, genericService, mapsAPILoader, nurseryManager, photosphereManager, activeRoute, zone, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.mapsAPILoader = mapsAPILoader;
        _this.nurseryManager = nurseryManager;
        _this.photosphereManager = photosphereManager;
        _this.activeRoute = activeRoute;
        _this.zone = zone;
        _this.alertUtils = alertUtils;
        _this.avgLat = MAP_INITIAL_LATITUDE;
        _this.zoom = 9;
        _this.avgLong = MAP_INITIAL_LONGITUDE;
        _this.isDrawing = false;
        _this.isDrawingNew = false;
        _this.polygonEditorVisible = false;
        _this.polygons = [];
        _this.currentPolygonProduct = null;
        _this.currentPolygonProductMeasure = null;
        _this.spheres = [];
        /* eslint-enable @typescript-eslint/no-explicit-any */
        _this.products = [];
        _this.nurseryUUID = "";
        _this.mapStyle = [];
        _this.mapStyle.push(MAP_STYLE);
        return _this;
    }
    NurseryMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            _this.nurseryUUID = params.id;
        });
        this.isShowingLinks = false;
        this.polylines = [];
        this.paths = [];
        this.subscribeGenericServices();
    };
    NurseryMapComponent.prototype.initDrawManager = function (map) {
        var _this = this;
        this.mapsAPILoader.load().then(function () {
            var polygonOptions = POLYGON_OPTIONS;
            var options = {
                drawingControl: false,
                drawingControlOptions: {
                    drawingModes: [
                        google.maps.drawing.OverlayType.MARKER,
                        google.maps.drawing.OverlayType.POLYGON
                    ]
                },
                polygonOptions: polygonOptions,
                drawingMode: null
            };
            _this.drawingManager = new google.maps.drawing.DrawingManager(options);
            _this.map = map;
            _this.drawingManager.setMap(map);
            _this.handleDeleteSelection();
            _this.SPHERE_MARKER = {
                url: "/assets/img/fogliolina.png",
                scaledSize: new google.maps.Size(35, 35)
            };
            _this.SPHERE_MARKER_ACTIVE = {
                url: "/assets/img/fogliolina_active.png",
                scaledSize: new google.maps.Size(35, 35)
            };
            _this.getSpheres();
            _this.addPolygonChangeEvent(_this.drawingManager);
        });
    };
    NurseryMapComponent.prototype.getSpheres = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.nurseryManager.getPolygons(10000, 0, this.nurseryUUID)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (polygonList) {
            if (polygonList.polygons) {
                var _loop_1 = function (polygon) {
                    if (polygon.geofences) {
                        var latLng = [];
                        var polygonBounds_1 = new google.maps.LatLngBounds();
                        for (var _i = 0, _a = polygon.geofences; _i < _a.length; _i++) {
                            var geoFence = _a[_i];
                            latLng.push(new google.maps.LatLng(geoFence.latitude, geoFence.longitude));
                            polygonBounds_1.extend(new google.maps.LatLng(geoFence.latitude, geoFence.longitude));
                        }
                        var polygonOptions = POLYGON_OPTIONS;
                        polygonOptions.path = latLng;
                        var mapsPoly = new google.maps.Polygon(polygonOptions);
                        mapsPoly.setMap(_this.map);
                        var newPoly_1 = {
                            pos: _this.polygons.length,
                            uuid: polygon.uuid,
                            uploaded: true,
                            polygon: mapsPoly,
                            productUUID: polygon.product ? polygon.product.uuid : null,
                            productInfo: polygon.productInfo
                        };
                        google.maps.event.addListener(mapsPoly, CLICK_EVENT, function () {
                            _this.zone.run(function () { return _this.editPolygon(newPoly_1.pos); });
                        });
                        google.maps.event.addListener(mapsPoly, MOUSE_OVER_EVENT, function () {
                            var language = _this.photosphereManager.getCurrentLanguage();
                            _this.polyInfo = polygon.product ? _this.getProductName(polygon.product, language) : null;
                            _this.infoWindowLat = polygonBounds_1.getCenter().lat();
                            _this.infoWindowLng = polygonBounds_1.getCenter().lng();
                            google.maps.event.trigger(_this.map, CLICK_EVENT, {
                                stop: null,
                                latLng: new google.maps.LatLng(0, 0)
                            });
                            if (_this.polyInfo !== null) {
                                _this.infoWindow.open();
                            }
                        });
                        google.maps.event.addListener(mapsPoly, MOUSE_OUT_EVENT, function () {
                            _this.infoWindow.close();
                        });
                        _this.polygons.push(newPoly_1);
                    }
                };
                for (var _i = 0, _a = polygonList.polygons; _i < _a.length; _i++) {
                    var polygon = _a[_i];
                    _loop_1(polygon);
                }
            }
        });
        this.photosphereManager.getPhotospheres(10000, 0, this.nurseryUUID)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (sphereList) {
            _this.spheres = [];
            _this.resetPolylines();
            if (sphereList.photospheres) {
                var lats = 0;
                var longs = 0;
                var _loop_2 = function (sphere) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(sphere.latitude, sphere.longitude),
                        icon: _this.SPHERE_MARKER
                    });
                    marker.setMap(_this.map);
                    google.maps.event.addListener(marker, CLICK_EVENT, function () {
                        if (!_this.isDrawing) {
                            if (_this.isAddingPath) {
                                marker.setIcon(_this.SPHERE_MARKER_ACTIVE);
                                if (_this.firstSelectedSphere) {
                                    _this.secondSelectedSphere = sphere;
                                    _this.addPath();
                                }
                                else {
                                    _this.firstSelectedSphere = sphere;
                                }
                            }
                            else if (_this.isDeletingSphere) {
                                _this.alertUtils.showConfirmAlert("PHOTOSPHERE_COMPONENT_DELETE_CONFIRM_TITLE_ALERT", "PHOTOSPHERE_COMPONENT_DELETE_CONFIRM_TEXT_ALERT", function () {
                                    _this.deletePhotosphere(sphere);
                                    return null;
                                }, function () {
                                    _this.toggleRemoveSphere();
                                    return null;
                                });
                            }
                            else {
                                _this.goToRouteByName(PRIVATE_NURSERY_SPHERE_ROUTE, { id: _this.nurseryUUID }, { start: sphere.uuid });
                            }
                        }
                    });
                    _this.spheres.push({
                        sphere: sphere,
                        marker: marker
                    });
                    lats += sphere.latitude;
                    longs += sphere.longitude;
                };
                for (var _i = 0, _a = sphereList.photospheres; _i < _a.length; _i++) {
                    var sphere = _a[_i];
                    _loop_2(sphere);
                }
                _this.avgLat = lats / sphereList.photospheres.length;
                _this.avgLong = longs / sphereList.photospheres.length;
                _this.zoom = 18;
            }
        });
        this.photosphereManager.getProducts()
            .subscribe(function (prods) {
            _this.products = prods;
        });
    };
    NurseryMapComponent.prototype.handleDeleteSelection = function () {
        var _this = this;
        var mouseIsDown = 0;
        var selectionBounds = null;
        var selectionBoundingBox = null;
        google.maps.event.addListener(this.map, "mousemove", function (e) {
            if (mouseIsDown && _this.isDeletingSphere) {
                if (selectionBoundingBox !== null) {
                    // box exists
                    selectionBounds.extend(e.latLng);
                    selectionBoundingBox.setBounds(selectionBounds);
                }
                else {
                    // create bounding box
                    selectionBounds = new google.maps.LatLngBounds();
                    selectionBounds.extend(e.latLng);
                    selectionBoundingBox = new google.maps.Rectangle({
                        map: _this.map,
                        bounds: selectionBounds,
                        fillOpacity: 0.15,
                        strokeWeight: 0.8,
                        clickable: false
                    });
                }
            }
        });
        google.maps.event.addListener(this.map, "mousedown", function () {
            if (_this.isDeletingSphere) {
                mouseIsDown = 1;
                _this.map.setOptions({
                    draggable: false
                });
            }
        });
        google.maps.event.addListener(this.map, "mouseup", function () {
            if (mouseIsDown && _this.isDeletingSphere) {
                mouseIsDown = 0;
                // box exists
                if (selectionBoundingBox !== null) {
                    // looping through my sphere/marker collection
                    var selectedSpheres_1 = new Map();
                    /* eslint-disable @typescript-eslint/prefer-for-of */
                    for (var i = 0; i < _this.spheres.length; i++) {
                        // in bounds check
                        if (selectionBoundingBox.getBounds().contains(_this.spheres[i].marker.getPosition())) {
                            // logData("User selected sphere: " + this.spheres[i].sphere.uuid);
                            _this.spheres[i].marker.setIcon(_this.SPHERE_MARKER_ACTIVE);
                            selectedSpheres_1.set(_this.spheres[i].sphere.uuid, _this.spheres[i].sphere);
                        }
                        else {
                            _this.spheres[i].marker.setIcon(_this.SPHERE_MARKER);
                            selectedSpheres_1.delete(_this.spheres[i].sphere.uuid);
                        }
                    }
                    // remove the rectangle
                    selectionBoundingBox.setMap(null);
                    if (selectedSpheres_1.size > 0) {
                        _this.sleep(500).then(function () {
                            // asks for confirmation
                            _this.alertUtils.showConfirmAlert("PHOTOSPHERE_COMPONENT_DELETE_SET_CONFIRM_TITLE_ALERT", "PHOTOSPHERE_COMPONENT_DELETE_SET_CONFIRM_TEXT_ALERT", function () {
                                _this.deletePhotosphereSet(selectedSpheres_1);
                                return null;
                            }, function () {
                                _this.toggleRemoveSphere();
                                /* eslint-disable @typescript-eslint/prefer-for-of */
                                for (var i = 0; i < _this.spheres.length; i++) {
                                    _this.spheres[i].marker.setIcon(_this.SPHERE_MARKER);
                                }
                                return null;
                            });
                        });
                    }
                }
                selectionBoundingBox = null;
            }
            _this.map.setOptions({
                draggable: true
            });
        });
    };
    NurseryMapComponent.prototype.sleep = function (ms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, ms); })
                            .then(function () { return logData("fired"); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NurseryMapComponent.prototype.deletePhotosphereSet = function (spheres) {
        var _this = this;
        // this.appComponent.startLoading();
        var firstUuid = spheres.values().next().value.uuid;
        this.photosphereManager.deletePhotosphere(firstUuid)
            .pipe(finalize(function () {
            // this.appComponent.stopLoading();
        }), mergeMap(function () {
            var calls = [];
            spheres.forEach(function (value) {
                if (value.uuid !== firstUuid) {
                    calls.push(_this.photosphereManager.deletePhotosphere(value.uuid));
                }
            });
            return forkJoin(calls);
        })).subscribe(function () {
            spheres.forEach(function (value) {
                var sphereIndex = _this.spheres.findIndex(function (item) {
                    return item.sphere.uuid === value.uuid;
                });
                _this.spheres[sphereIndex].marker.setMap(null);
                _this.spheres.splice(sphereIndex, 1);
            });
            _this.toggleRemoveSphere();
        });
    };
    NurseryMapComponent.prototype.addPolygonChangeEvent = function (drawingManager) {
        var _this = this;
        google.maps.event.addListener(drawingManager, POLYGON_COMPLETE_EVENT, function (event) {
            if (event.getPath().getLength() > 2) {
                var polygon_1 = {
                    pos: _this.polygons.length,
                    uuid: "temp" + new Date(),
                    uploaded: false,
                    polygon: event,
                    productUUID: null,
                    productInfo: null
                };
                _this.polygons.push(polygon_1);
                google.maps.event.addListener(event, CLICK_EVENT, function () {
                    _this.zone.run(function () { return _this.editPolygon(polygon_1.pos); });
                });
                _this.editPolygon(polygon_1.pos);
            }
            else {
                event.setMap(null);
            }
        });
    };
    NurseryMapComponent.prototype.onEditPolygons = function () {
        if (!this.polygonEditorVisible) {
            this.isDrawing = !this.isDrawing;
            this.isDrawingNew = this.isDrawing;
            if (this.isDrawing) {
                this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            }
            else {
                this.drawingManager.setDrawingMode(null);
            }
            this.toggleSpheres();
        }
    };
    NurseryMapComponent.prototype.onDrawingEdit = function () {
        if (this.isDrawing && this.isDrawingNew) {
            this.isDrawingNew = false;
            this.drawingManager.setDrawingMode(null);
        }
    };
    NurseryMapComponent.prototype.onDrawingNew = function () {
        if (this.isDrawing && !this.isDrawingNew) {
            this.isDrawingNew = true;
            this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        }
    };
    NurseryMapComponent.prototype.toggleSpheres = function () {
        var _this = this;
        if (this.spheres) {
            this.spheres.forEach(function (sphere) {
                if (sphere.marker) {
                    sphere.marker.setVisible(!_this.isDrawing);
                }
            });
        }
    };
    NurseryMapComponent.prototype.editPolygon = function (pos) {
        if (this.isDrawing && !this.polygonEditorVisible) {
            this.currentPolygon = pos;
            this.currentPolygonProduct = this.polygons[this.currentPolygon].productUUID;
            this.currentPolygonProductMeasure = this.polygons[this.currentPolygon].productInfo;
            this.polygonEditorVisible = true;
            this.drawingManager.setDrawingMode(null);
        }
    };
    NurseryMapComponent.prototype.togglePolylines = function () {
        var _this = this;
        if (this.isShowingLinks) {
            this.resetPolylines();
        }
        else {
            this.isShowingLinks = true;
            var _loop_3 = function (obj) {
                var links = obj.sphere.markers.filter(function (item) {
                    return item.markerType === "PHOTOSPHERE";
                });
                var _loop_4 = function (link) {
                    var linkedSphere = this_1.spheres.find(function (item) {
                        return item.sphere.uuid === link.linkedPhotosphereUUID;
                    });
                    if (linkedSphere) {
                        var existingPath = this_1.paths.find(function (item) {
                            return (item.start === obj.sphere.uuid && item.end === linkedSphere.sphere.uuid) ||
                                (item.end === obj.sphere.uuid && item.start === linkedSphere.sphere.uuid);
                        });
                        if (!existingPath) {
                            var path = [
                                { lat: obj.sphere.latitude, lng: obj.sphere.longitude },
                                { lat: linkedSphere.sphere.latitude, lng: linkedSphere.sphere.longitude }
                            ];
                            var polyline = new google.maps.Polyline({
                                path: path,
                                geodesic: true,
                                strokeColor: (link.enabled) ? "#FF0000" : "#666666",
                                strokeOpacity: 1.0,
                                strokeWeight: 4
                            });
                            var polylineItem_1 = new PolylineItem(obj, link, polyline);
                            polyline.addListener("click", function () {
                                _this.onPolylineClick(polylineItem_1);
                            });
                            polyline.setMap(this_1.map);
                            this_1.paths.push(new PathItem(obj.sphere.uuid, linkedSphere.sphere.uuid));
                            this_1.polylines.push(polylineItem_1);
                        }
                    }
                };
                for (var _i = 0, links_1 = links; _i < links_1.length; _i++) {
                    var link = links_1[_i];
                    _loop_4(link);
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.spheres; _i < _a.length; _i++) {
                var obj = _a[_i];
                _loop_3(obj);
            }
        }
    };
    NurseryMapComponent.prototype.resetPolylines = function () {
        this.isShowingLinks = false;
        this.selectedPolyline = null;
        for (var _i = 0, _a = this.polylines; _i < _a.length; _i++) {
            var item = _a[_i];
            item.polyline.setMap(null);
        }
        this.paths = [];
        this.polylines = [];
    };
    NurseryMapComponent.prototype.toggleAddPath = function () {
        this.isAddingPath = !this.isAddingPath;
        if (this.isAddingPath) {
            this.selectedPolyline = null;
            this.resetSelectedPolilyne();
        }
    };
    NurseryMapComponent.prototype.toggleRemoveSphere = function () {
        this.isDeletingSphere = !this.isDeletingSphere;
    };
    NurseryMapComponent.prototype.deletePhotosphere = function (sphere) {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.deletePhotosphere(sphere.uuid)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            var sphereIndex = _this.spheres.findIndex(function (item) {
                return item.sphere.uuid === sphere.uuid;
            });
            _this.spheres[sphereIndex].marker.setMap(null);
            _this.spheres.splice(sphereIndex, 1);
            _this.toggleRemoveSphere();
        });
    };
    NurseryMapComponent.prototype.onPolylineClick = function (polylineItem) {
        if (!this.isAddingPath) {
            var select = polylineItem.polyline.strokeColor !== "blue";
            this.resetSelectedPolilyne();
            if (select) {
                polylineItem.polyline.setOptions({ strokeColor: "blue" });
                this.selectedPolyline = polylineItem;
            }
            else {
                this.selectedPolyline = null;
            }
        }
    };
    NurseryMapComponent.prototype.resetSelectedPolilyne = function () {
        var active = this.polylines.filter(function (item) {
            return item.polyline.strokeColor === "blue";
        });
        for (var _i = 0, active_1 = active; _i < active_1.length; _i++) {
            var obj = active_1[_i];
            obj.polyline.setOptions({ strokeColor: (obj.link.enabled) ? "#FF0000" : "#666666" });
        }
    };
    NurseryMapComponent.prototype.addPath = function () {
        var _this = this;
        if (this.firstSelectedSphere && this.secondSelectedSphere) {
            // TODO: check if already exists ??
            var firstSphere_1 = this.firstSelectedSphere;
            var secondSphere_1 = this.secondSelectedSphere;
            var firstMarkerBody = {
                "marker_type": "PHOTOSPHERE",
                "position_yaw": 0,
                "position_pitch": 0,
                "position_distance": null,
                "favourite": false,
                "enabled": true,
                "photosphere_uuid": firstSphere_1.uuid,
                "product_id_cod": null,
                "linked_photosphere_uuid": secondSphere_1.uuid,
                "promotion_uuid": null,
                "product_info": null
            };
            var secondMarkerBody_1 = {
                "marker_type": "PHOTOSPHERE",
                "position_yaw": 0,
                "position_pitch": 0,
                "position_distance": null,
                "favourite": false,
                "enabled": true,
                "photosphere_uuid": secondSphere_1.uuid,
                "product_id_cod": null,
                "linked_photosphere_uuid": firstSphere_1.uuid,
                "promotion_uuid": null,
                "product_info": null
            };
            this.appComponent.startLoading();
            this.photosphereManager.addMarker(firstMarkerBody)
                .pipe().subscribe(function (marker) {
                // Add marker to sphere
                firstSphere_1.markers.push(marker);
                _this.photosphereManager.addMarker(secondMarkerBody_1)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function (marker2) {
                    // Reset addition vars
                    _this.toggleAddPath();
                    _this.resetSelectedSpheres();
                    // Add marker to sphere
                    secondSphere_1.markers.push(marker2);
                    // Add path to active ones (if not already exists)
                    var existingPath = _this.paths.find(function (item) {
                        return (item.start === firstSphere_1.uuid && item.end === secondSphere_1.uuid) ||
                            (item.end === firstSphere_1.uuid && item.start === secondSphere_1.uuid);
                    });
                    if (!existingPath) {
                        var path = [
                            { lat: firstSphere_1.latitude, lng: firstSphere_1.longitude },
                            { lat: secondSphere_1.latitude, lng: secondSphere_1.longitude }
                        ];
                        var polyline = new google.maps.Polyline({
                            path: path,
                            geodesic: true,
                            strokeColor: "#FF0000",
                            strokeOpacity: 1.0,
                            strokeWeight: 4
                        });
                        var polylineItem_2 = new PolylineItem({ sphere: firstSphere_1 }, marker, polyline);
                        polyline.addListener("click", function () {
                            _this.onPolylineClick(polylineItem_2);
                        });
                        polyline.setMap(_this.map);
                        _this.paths.push(new PathItem(firstSphere_1.uuid, secondSphere_1.uuid));
                        _this.polylines.push(polylineItem_2);
                    }
                    // Reset active sphere markers
                    var activeIcon = _this.SPHERE_MARKER_ACTIVE;
                    var spheresWithActiveMarkers = _this.spheres.filter(function (item) {
                        var icon = item.marker.getIcon();
                        return icon.url === activeIcon.url;
                    });
                    for (var _i = 0, spheresWithActiveMarkers_1 = spheresWithActiveMarkers; _i < spheresWithActiveMarkers_1.length; _i++) {
                        var item = spheresWithActiveMarkers_1[_i];
                        item.marker.setIcon(_this.SPHERE_MARKER);
                    }
                });
            });
        }
    };
    NurseryMapComponent.prototype.resetSelectedSpheres = function () {
        this.firstSelectedSphere = null;
        this.secondSelectedSphere = null;
    };
    NurseryMapComponent.prototype.removePath = function () {
        var _this = this;
        var selectedSphere = this.selectedPolyline.sphere;
        var selectedMarker = this.selectedPolyline.link;
        var linkedSphere = this.spheres.find(function (item) {
            return item.sphere.uuid === selectedMarker.linkedPhotosphereUUID;
        });
        var oppositeMarker = linkedSphere.sphere.markers.find(function (item) {
            return item.linkedPhotosphereUUID === selectedSphere.sphere.uuid;
        });
        this.appComponent.startLoading();
        if (oppositeMarker) {
            this.photosphereManager.deleteMarker(selectedMarker.uuid)
                .pipe().subscribe(function () {
                _this.photosphereManager.deleteMarker(oppositeMarker.uuid)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function () {
                    // Removes markers from local sphere
                    var fsIndex = selectedSphere.sphere.markers.findIndex(function (item) {
                        return item.uuid === selectedMarker.uuid;
                    });
                    selectedSphere.sphere.markers.splice(fsIndex, 1);
                    var ssIndex = linkedSphere.sphere.markers.findIndex(function (item) {
                        return item.uuid === oppositeMarker.uuid;
                    });
                    linkedSphere.sphere.markers.splice(ssIndex, 1);
                    // Reset selected polyline
                    _this.resetSelectedPolilyne();
                    _this.selectedPolyline = null;
                    // Removes path line
                    var plIndex = _this.polylines.findIndex(function (item) {
                        return (item.link.uuid === selectedMarker.uuid) || (item.link.uuid === oppositeMarker.uuid);
                    });
                    _this.polylines[plIndex].polyline.setMap(null);
                    _this.polylines.splice(plIndex, 1);
                    var pathIndex = _this.paths.findIndex(function (item) {
                        return (item.start === selectedSphere.sphere.uuid &&
                            item.end === linkedSphere.sphere.uuid) ||
                            (item.end === selectedSphere.sphere.uuid &&
                                item.start === linkedSphere.sphere.uuid);
                    });
                    _this.paths.splice(pathIndex, 1);
                });
            });
        }
        else {
            this.photosphereManager.deleteMarker(selectedMarker.uuid)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function () {
                // Removes marker from local sphere
                var index = selectedSphere.sphere.markers.findIndex(function (item) { return item.uuid === selectedMarker.uuid; });
                selectedSphere.sphere.markers.splice(index, 1);
                // Reset selected polyline
                _this.resetSelectedPolilyne();
                _this.selectedPolyline = null;
                // Removes path line
                var plIndex = _this.polylines.findIndex(function (item) { return item.link.uuid === selectedMarker.uuid; });
                _this.polylines[plIndex].polyline.setMap(null);
                _this.polylines.splice(plIndex, 1);
                var pathIndex = _this.paths.findIndex(function (item) {
                    return (item.start === selectedSphere.sphere.uuid && item.end === linkedSphere.sphere.uuid) ||
                        (item.end === selectedSphere.sphere.uuid && item.start === linkedSphere.sphere.uuid);
                });
                _this.paths.splice(pathIndex, 1);
            });
        }
    };
    NurseryMapComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    NurseryMapComponent.prototype.onPolygonSave = function (event) {
        var _this = this;
        if (event.product) {
            this.appComponent.startLoading();
            if (this.polygons[this.currentPolygon].uploaded) {
                this.nurseryManager.editPolygon(this.polygons[this.currentPolygon].uuid, event.product, event.productInfo)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function (poly) {
                    _this.polygons[_this.currentPolygon].productUUID = poly.product.uuid;
                    _this.polygons[_this.currentPolygon].productInfo = poly.productInfo;
                    _this.polygonEditorVisible = false;
                    if (_this.isDrawingNew) {
                        _this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
                    }
                });
            }
            else {
                this.nurseryManager.addPolygon(this.polygons[this.currentPolygon].polygon, event.product, this.nurseryUUID, event.productInfo)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function (poly) {
                    _this.polygons[_this.currentPolygon].uuid = poly.uuid;
                    _this.polygons[_this.currentPolygon].productUUID = poly.product.uuid;
                    _this.polygons[_this.currentPolygon].productInfo = poly.productInfo;
                    _this.polygons[_this.currentPolygon].uploaded = true;
                    _this.polygonEditorVisible = false;
                    if (_this.isDrawingNew) {
                        _this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
                    }
                });
            }
        }
    };
    NurseryMapComponent.prototype.onPolygonDelete = function () {
        var _this = this;
        this.alertUtils.showConfirmAlert("NURSERY_MAP_DELETE_POLYGON_CONFIRM_TITLE_ALERT", "NURSERY_MAP_DELETE_POLYGON_CONFIRM_TEXT_ALERT", function () {
            _this.deletePolygon();
            return null;
        }, function () {
            logData("close");
            return null;
        });
    };
    NurseryMapComponent.prototype.deletePolygon = function () {
        var _this = this;
        if (this.polygons[this.currentPolygon].uploaded) {
            this.appComponent.startLoading();
            this.nurseryManager.deletePolygon(this.polygons[this.currentPolygon].uuid)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                .subscribe({
                complete: function () {
                    _this.polygons[_this.currentPolygon].polygon.setMap(null);
                    _this.polygons[_this.currentPolygon] = null;
                    _this.polygonEditorVisible = false;
                    if (_this.isDrawingNew) {
                        _this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
                    }
                }
            });
        }
        else {
            this.polygons[this.currentPolygon].polygon.setMap(null);
            this.polygons[this.currentPolygon] = null;
            this.polygonEditorVisible = false;
            if (this.isDrawingNew) {
                this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            }
        }
    };
    NurseryMapComponent.prototype.onShortcuts = function () {
        this.isShowingShortcuts = !this.isShowingShortcuts;
    };
    NurseryMapComponent.prototype.onSphereChosen = function (event) {
        this.goToRouteByName(PRIVATE_NURSERY_SPHERE_ROUTE, { id: this.nurseryUUID }, { start: event });
    };
    NurseryMapComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_DETAIL_ROUTE, { id: _this.nurseryUUID });
        });
    };
    NurseryMapComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    return NurseryMapComponent;
}(BaseComponent));
export { NurseryMapComponent };
